import { app_permissions } from '../security/app-permissions';
import { SelectOption } from './audit.models';

export const auditNavItems = [
  { label: 'Dashboard', icon: 'pi pi-chart-bar', route: '/audit', permission: app_permissions.audit.dashboard.view },
  { label: 'Programs', icon: 'pi pi-sitemap', route: '/audit/programs', permission: app_permissions.audit.programs.view },
  { label: 'Templates', icon: 'pi pi-list-check', route: '/audit/templates', permission: app_permissions.audit.templates.view },
  { label: 'Cases', icon: 'pi pi-briefcase', route: '/audit/cases', permission: app_permissions.audit.cases.view },
  { label: 'Findings', icon: 'pi pi-exclamation-triangle', route: '/audit/findings', permission: app_permissions.audit.findings.view },
  { label: 'Actions', icon: 'pi pi-check-square', route: '/audit/actions', permission: app_permissions.audit.actions.view },
  { label: 'Root Causes', icon: 'pi pi-chart-line', route: '/audit/reports/root-cause-trends', permission: app_permissions.audit.reports.view },
  { label: 'Evidence', icon: 'pi pi-database', route: '/audit/evidence', permission: app_permissions.audit.evidence.view }
];

export const moduleOptions: SelectOption<string>[] = [
  { label: 'Fleet', value: 'FLEET' },
  { label: 'Shipments', value: 'SHIPMENTS' },
  { label: 'Warehouse', value: 'WAREHOUSING' },
  { label: 'Finance', value: 'ACCOUNTING' },
  { label: 'Contracts', value: 'CONTRACTS' },
  { label: 'Clearance', value: 'CUSTOMS_CLEARANCE' },
  { label: 'Partner Management', value: 'PARTNER_MANAGEMENT' },
  { label: 'Operations', value: 'OPERATIONS' }
];

export const auditTypeOptions: SelectOption<string>[] = [
  { label: 'Compliance', value: 'COMPLIANCE' },
  { label: 'Operational', value: 'OPERATIONAL' },
  { label: 'Financial', value: 'FINANCIAL' },
  { label: 'Safety', value: 'SAFETY' },
  { label: 'Quality', value: 'QUALITY' },
  { label: 'Inventory', value: 'INVENTORY' }
];

export const scopeTypeOptions: SelectOption<string>[] = [
  { label: 'Company', value: 'COMPANY' },
  { label: 'Branch', value: 'BRANCH' },
  { label: 'Vehicle', value: 'VEHICLE' },
  { label: 'Driver', value: 'DRIVER' },
  { label: 'Shipment', value: 'SHIPMENT' },
  { label: 'Vendor', value: 'VENDOR' },
  { label: 'Document', value: 'DOCUMENT' },
  { label: 'Custom', value: 'CUSTOM' }
];

export const riskOptions: SelectOption<string>[] = [
  { label: 'Low', value: 'LOW' },
  { label: 'Medium', value: 'MEDIUM' },
  { label: 'High', value: 'HIGH' },
  { label: 'Critical', value: 'CRITICAL' }
];

export const frequencyOptions: SelectOption<string>[] = [
  { label: 'Ad hoc', value: 'AD_HOC' },
  { label: 'Daily', value: 'DAILY' },
  { label: 'Weekly', value: 'WEEKLY' },
  { label: 'Monthly', value: 'MONTHLY' },
  { label: 'Quarterly', value: 'QUARTERLY' },
  { label: 'Annual', value: 'ANNUAL' }
];

export const answerTypeOptions: SelectOption<string>[] = [
  { label: 'Pass / Fail', value: 'PASS_FAIL' },
  { label: 'Yes / No', value: 'YES_NO' },
  { label: 'Score', value: 'SCORE' },
  { label: 'Text', value: 'TEXT' },
  { label: 'Number', value: 'NUMBER' }
];

export const responseResultOptions: SelectOption<string>[] = [
  { label: 'Pass', value: 'PASS' },
  { label: 'Fail', value: 'FAIL' },
  { label: 'Not Applicable', value: 'NA' }
];

export const reviewResultOptions: SelectOption<string>[] = [
  { label: 'Passed', value: 'PASSED' },
  { label: 'Failed', value: 'FAILED' },
  { label: 'Needs Correction', value: 'NEEDS_CORRECTION' }
];

export const severityOptions: SelectOption<string>[] = [
  { label: 'Low', value: 'LOW' },
  { label: 'Medium', value: 'MEDIUM' },
  { label: 'High', value: 'HIGH' },
  { label: 'Critical', value: 'CRITICAL' }
];

export const findingTypeOptions: SelectOption<string>[] = [
  { label: 'Nonconformity', value: 'NONCONFORMITY' },
  { label: 'Observation', value: 'OBSERVATION' },
  { label: 'Risk', value: 'RISK' },
  { label: 'Improvement', value: 'IMPROVEMENT' },
  { label: 'Fraud Indicator', value: 'FRAUD_INDICATOR' },
  { label: 'Policy Exception', value: 'POLICY_EXCEPTION' },
  { label: 'Compliance', value: 'COMPLIANCE' }
];

export const impactScopeOptions: SelectOption<string>[] = [
  { label: 'Internal', value: 'INTERNAL' },
  { label: 'Customer', value: 'CUSTOMER' },
  { label: 'Carrier', value: 'CARRIER' },
  { label: 'Customer and Carrier', value: 'CUSTOMER_CARRIER' },
  { label: 'Financial', value: 'FINANCIAL' },
  { label: 'Safety', value: 'SAFETY' },
  { label: 'Regulatory', value: 'REGULATORY' }
];

export const escalationLevelOptions: SelectOption<string>[] = [
  { label: 'Level 1', value: 'L1' },
  { label: 'Level 2', value: 'L2' },
  { label: 'Level 3', value: 'L3' }
];

export const escalationStatusOptions: SelectOption<string>[] = [
  { label: 'Open', value: 'OPEN' },
  { label: 'Watch', value: 'WATCH' },
  { label: 'Escalated', value: 'ESCALATED' },
  { label: 'Resolved', value: 'RESOLVED' }
];

export const booleanFilterOptions: SelectOption<boolean | null>[] = [
  { label: 'All', value: null },
  { label: 'Yes', value: true },
  { label: 'No', value: false }
];

export const findingStatusOptions: SelectOption<string>[] = [
  { label: 'Open', value: 'OPEN' },
  { label: 'Action Required', value: 'ACTION_REQUIRED' },
  { label: 'In Progress', value: 'IN_PROGRESS' },
  { label: 'Ready for Verification', value: 'READY_FOR_VERIFICATION' },
  { label: 'Verified', value: 'VERIFIED' },
  { label: 'Rejected', value: 'REJECTED' },
  { label: 'Closed', value: 'CLOSED' }
];

export const actionTypeOptions: SelectOption<string>[] = [
  { label: 'Corrective', value: 'CORRECTIVE' },
  { label: 'Preventive', value: 'PREVENTIVE' },
  { label: 'Corrective + Preventive', value: 'CORRECTIVE_PREVENTIVE' },
  { label: 'Recovery', value: 'RECOVERY' },
  { label: 'Training', value: 'TRAINING' },
  { label: 'Document Update', value: 'DOCUMENT_UPDATE' },
  { label: 'System Fix', value: 'SYSTEM_FIX' },
  { label: 'Process Change', value: 'PROCESS_CHANGE' }
];

export const actionPriorityOptions: SelectOption<string>[] = [
  { label: 'Low', value: 'LOW' },
  { label: 'Medium', value: 'MEDIUM' },
  { label: 'High', value: 'HIGH' },
  { label: 'Critical', value: 'CRITICAL' }
];

export const actionStatusOptions: SelectOption<string>[] = [
  { label: 'Open', value: 'OPEN' },
  { label: 'In Progress', value: 'IN_PROGRESS' },
  { label: 'Submitted', value: 'SUBMITTED' },
  { label: 'Verified', value: 'VERIFIED' },
  { label: 'Rejected', value: 'REJECTED' },
  { label: 'Escalated', value: 'ESCALATED' },
  { label: 'Closed', value: 'CLOSED' }
];

export const effectivenessOptions: SelectOption<string>[] = [
  { label: 'Effective', value: 'EFFECTIVE' },
  { label: 'Partially Effective', value: 'PARTIALLY_EFFECTIVE' },
  { label: 'Not Effective', value: 'NOT_EFFECTIVE' },
  { label: 'Pending Check', value: 'PENDING_CHECK' }
];

export const actionLinkTypeOptions: SelectOption<string>[] = [
  { label: 'Training', value: 'TRAINING' },
  { label: 'Process Change', value: 'PROCESS_CHANGE' },
  { label: 'System Change', value: 'SYSTEM_CHANGE' },
  { label: 'Document Update', value: 'DOCUMENT_UPDATE' },
  { label: 'Related Action', value: 'RELATED_ACTION' },
  { label: 'External Reference', value: 'EXTERNAL_REFERENCE' }
];

export const evidenceTypeOptions: SelectOption<string>[] = [
  { label: 'Document', value: 'DOCUMENT' },
  { label: 'Photo', value: 'PHOTO' },
  { label: 'System Record', value: 'SYSTEM_RECORD' },
  { label: 'Source Snapshot', value: 'SOURCE_SNAPSHOT' },
  { label: 'Domain Event', value: 'DOMAIN_EVENT' },
  { label: 'API Response', value: 'API_RESPONSE' },
  { label: 'External Link', value: 'EXTERNAL_LINK' },
  { label: 'Comment', value: 'COMMENT' }
];

export const sourceModuleFallbackOptions: SelectOption<string>[] = [
  { label: 'Shipments', value: 'SHIPMENTS' },
  { label: 'CRM', value: 'CRM' },
  { label: 'Contracts', value: 'CONTRACTS' },
  { label: 'Fleet', value: 'FLEET' },
  { label: 'Clearance', value: 'CLEARANCE' },
  { label: 'Container Tracking', value: 'CONTAINER_TRACKING' },
  { label: 'Warehousing', value: 'WAREHOUSING' },
  { label: 'POSM', value: 'POSM' },
  { label: 'Accounts', value: 'ACCOUNTS' },
  { label: 'Payment', value: 'PAYMENT' },
  { label: 'Business Events', value: 'BUSINESS_EVENTS' },
  { label: 'Workflow', value: 'WORKFLOW' }
];

export function statusSeverity(status?: string): 'success' | 'secondary' | 'info' | 'warn' | 'danger' | 'contrast' {
  switch ((status || '').toUpperCase()) {
    case 'PUBLISHED':
    case 'PASSED':
    case 'CLOSED':
    case 'ACTIVE':
    case 'RESOLVED':
      return 'success';
    case 'DRAFT':
      return 'secondary';
    case 'IN_PROGRESS':
    case 'SUBMITTED':
    case 'READY_FOR_VERIFICATION':
    case 'VERIFIED':
      return 'info';
    case 'NEEDS_CORRECTION':
    case 'OPEN':
    case 'ACTION_REQUIRED':
    case 'WATCH':
      return 'warn';
    case 'FAILED':
    case 'CRITICAL':
    case 'REJECTED':
    case 'ESCALATED':
      return 'danger';
    default:
      return 'secondary';
  }
}

export function formatAuditDate(value?: string | Date | null): string {
  if (!value) {
    return '-';
  }
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? '-' : date.toLocaleString();
}

export function isAuditOverdue(value?: string | Date | null, status?: string): boolean {
  if (!value || ['CLOSED', 'VERIFIED'].includes((status || '').toUpperCase())) {
    return false;
  }
  const date = value instanceof Date ? value : new Date(value);
  return !Number.isNaN(date.getTime()) && date.getTime() < Date.now();
}

export function auditDaysOverdue(value?: string | Date | null, status?: string): number {
  if (!isAuditOverdue(value, status)) {
    return 0;
  }
  const date = value instanceof Date ? value : new Date(value!);
  return Math.max(1, Math.floor((Date.now() - date.getTime()) / 86_400_000));
}
